import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    all: [],
    single: null,
    createFormData: null,
    inlineEditingData: null
  },
  actions,
  getters,
  mutations
}
